import { FunctionComponent } from "react";

import { useMediaQuery } from "../../hooks/useMediaQuery";

import { DashboardMobilePopupDisplayProps, DashboardMobilePopupDisplay } from "./DashboardMobilePopupDisplay";

interface DashboardMobilePopupProps extends DashboardMobilePopupDisplayProps {
  shouldDisplay: boolean;
}

export const DashboardMobilePopup: FunctionComponent<React.PropsWithChildren<DashboardMobilePopupProps>> = ({
  children,
  popupContent,
  shouldDisplay,
  onClose,
}) => {
  const { isSmallScreen } = useMediaQuery();

  if (isSmallScreen && shouldDisplay) {
    return (
      <DashboardMobilePopupDisplay popupContent={popupContent} onClose={onClose}>
        {children}
      </DashboardMobilePopupDisplay>
    );
  }
  return <>{children}</>;
};
